<section class="profile-section">
	<header class="row page-header">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<h2 class=title>{{name}}</h2>
				</div>
				<div class="col-md-6 text-end">
					<a routerLink="/useraccount/user/editprofile">
						<span class="btn btn-success">edit profile</span>
					</a>
				</div>
			</div>
		</div>
	</header>
	<main>
		<div class="container">
			<div class="form-section">

                <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                    <span class="visually-hidden">Error:</span> {{ errorMessage }}
                </div>

                <form [formGroup]="userProfileForm">

                    <div class="row">
                        <div class="col-md-2 text-center">
                            <sp-profileimage isProfileImage="true" isLarge="true" updatedImage="{{image}}"></sp-profileimage>                            
                            
                            <button id="btnProfilePhotoBrowse" class="btn btn-action" style="margin-right: 5px;">Update photo</button>
                            
                            <dx-file-uploader                    
                                #dxProfilePhotoUpload  
                                dialogTrigger="#btnProfilePhotoBrowse"      
                                [visible]="false"                            
                                [multiple]="false"                                             
                                uploadMode="instantly"                                        
                                (onUploaded)="onDxUploaded()"                                
                                (onValueChanged)="onDxValueChanged($event)">
                            </dx-file-uploader>                            
                        </div>
                        
                        <div class="col-md-10">
                            <div class="row top-buffer-20">
                                <div class="col-md-12">
                                    <label class="small">Name</label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <label class="user-name-value">{{name}}</label>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-12">
                                    <label class="small">Phone</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>{{phone}}</label>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-12">
                                    <label class="small">Email</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>{{email}}</label>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-12">
                                    <label class="small">Password</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <a [routerLink]="['/useraccount/user/changepassword']">Update password</a>
                                </div>
                            </div>

                            <div class="row top-buffer-20">
                                <div class="col-md-12">
                                    <label class="small">Joined</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>{{joinedOn | date: 'MMM dd, yyyy'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
		</div>
	</main>
</section>
